/**
 * Use this section to customize add custom scripting to the multiple shipping
 * address pages. This field accepts both liquid and javascript, and is rendered
 * within a script tag.
 */

// Example
var customLogger = {};

customLogger.log = function(action) {
  //console.log(action)
}

customLogger.log('Hello World, my shop name is {{ shop.name }}');
